import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import creditDocumentListAction from './creditDocumentList.action.json' with { type: 'json' }
import { creditDocumentObject } from '../creditDocumentObject'

export const creditDocumentExpression = expression(creditDocumentObject.shape)

const creditDocumentListDefinition = defineAction({
  ...creditDocumentListAction,

  input: z.object({
    filter: creditDocumentExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      fileName: 'Nome do arquivo',
      mimeType: 'Tipo MIME',
      status: 'Status',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(creditDocumentObject),
    count: z.number(),
  }),
})

export default creditDocumentListDefinition

